// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rounded-button[data-v-9335ea3a]{background-color:transparent;border-radius:4px;border:1px solid #e5e5e5;height:44px;cursor:pointer;padding:0 28px 0 24px;display:flex;flex-direction:row;align-items:center;justify-content:center;font-style:normal;font-weight:500;font-size:16px;line-height:22px}.rounded-button[data-v-9335ea3a]:active{background-color:#fafafa}.rounded-button[data-v-9335ea3a]:disabled{background-color:#fafafa;color:#969696}", ""]);
// Exports
module.exports = exports;
